import { ThemeProvider, useTheme } from '../../contexts/ThemeContext';
import Hero from './components/Hero';
import Services from './components/Services';
import Industries from './components/Industries';
import HowItWorks from './components/HowItWorks';
import Benefits from './components/Benefits';
import Footer from './components/Footer';

function HomeContent() {
  const { isDark } = useTheme();
  return (
    <div
      className="min-h-screen transition-colors duration-300"
      style={{ background: isDark ? '#0f1117' : '#F3F4F6' }}
    >
      <Hero />
      <Services />
      <Industries />
      <HowItWorks />
      <Benefits />
      <Footer />
    </div>
  );
}

export default function Home() {
  return (
    <ThemeProvider>
      <HomeContent />
    </ThemeProvider>
  );
}
